import { Box } from "@mui/material";
import React, { useRef } from "react";
import useHoverAction from "../hooks/useHoverAction";
import DeleteButton from "../components/DeleteButton";
import theme from "Theme/AppTheme";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import { ConcatFieldValueType } from "../types";
import AcxMainTextField from "components/UI/AcxMainTextField";
import { selectCustomStyle } from "../helpers/componentUtils";

interface ConcatValueFieldProps {
    field: ConcatFieldValueType;
    hasError?: boolean;
    sourceFieldOptions: { label: string; value: string }[];
    updateField: (value: string) => void;
    removeField: () => void;
}

const ConcatValueField: React.FC<ConcatValueFieldProps> = ({
    field,
    hasError,
    updateField,
    removeField,
    sourceFieldOptions,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { showAction, handlers } = useHoverAction(containerRef);

    const { id, type, value } = field;

    return (
        <Box
            ref={containerRef}
            {...handlers}
            sx={{ display: "flex", gap: 1.5 }}
        >
            {type === "field" && (
                <AcxSelect
                    fullWidth
                    customStyle={selectCustomStyle({ flex: 1 })}
                    id={`${id}-${field}`}
                    options={sourceFieldOptions}
                    placeholder="Select fields to combine"
                    labelField="label"
                    valueField="value"
                    defaultValue={sourceFieldOptions.find(
                        (option) => option.value === value,
                    )}
                    error={hasError && !value}
                    onChange={(e) => updateField(e.value)}
                />
            )}
            {type === "separator" && (
                <AcxMainTextField
                    fullWidth
                    containerStyle={{ flex: 1 }}
                    placeholderText="Specify a separator"
                    id={`${id}-separator`}
                    value={value}
                    error={hasError && !value}
                    hideErrorIcon
                    onChange={(e) => updateField(e.target.value)}
                />
            )}
            <DeleteButton
                onDelete={removeField}
                showDelete={showAction}
                sx={{
                    top: theme.spacing(1),
                    right: theme.spacing(1),
                }}
            />
        </Box>
    );
};

export default ConcatValueField;
